import React from "react";
import '../../sass/components/flexibleModules/_components.comparisonTableModule.scss';

const ComparisonTableModule = ({ data }) => {
    return (
        <div class="cp-comparisonTableModule">
            <div class="cp-comparisonTableModule__inner">
                {data.comparisonTableMainSectionHeader &&
                    <h2>{data.comparisonTableMainSectionHeader}</h2>
                }
                <div className="cp-comparisonTableModule__top l--flex">
                    {data.comparisonTableLogoOne &&
                        <div>
                            <img loading="lazy" src={data.comparisonTableLogoOne.sourceUrl} alt={data.comparisonTableLogoOne.altText} />
                        </div>
                    }
                    {data.comparisonTableVs &&
                        <span>{data.comparisonTableVs}</span>
                    }
                    {data.comparisonTableLogoTwo &&
                        <div>
                            <img loading="lazy" src={data.comparisonTableLogoTwo.sourceUrl} alt={data.comparisonTableLogoTwo.altText} />
                        </div>

                    }
                </div>
                {data.comparisonTableSections &&
                    <div className="cp-comparisonTableModule__bottom">
                        {data.comparisonTableSections.map((table, index) => (
                            <div className="cp-comparisonTableModule__bottom-section l--flex" key={index}>
                                {table.comparisonTableSectionsMiddle &&
                                    <div className="l-middle l--mobile">
                                        <img loading="lazy" src={table.comparisonTableSectionsMiddle.sourceUrl} alt={table.comparisonTableSectionsMiddle.altText} />
                                        {table.comparisonTableSectionsMiddleText &&
                                            <span dangerouslySetInnerHTML={{__html: table.comparisonTableSectionsMiddleText}} />
                                        }
                                    </div>
                                }
                                {table.comparisonTableSectionsLeft &&
                                    <div className="l-left">
                                        {data.comparisonTableLogoOne &&
                                            <div className="l--mobile">
                                                <img loading="lazy" src={data.comparisonTableLogoOne.sourceUrl} alt={data.comparisonTableLogoOne.altText} />
                                            </div>
                                        }
                                        {table.comparisonTableSectionsLeft.map((data, index) => (
                                            <div className="l-left__content" key={index}>
                                                {data.header ?
                                                    <h4>{data.header}</h4>
                                                    :
                                                    <h4 className="l-transform">no header</h4>
                                                }
                                                {data.teaser &&
                                                    <p dangerouslySetInnerHTML={{ __html: data.teaser }} />
                                                }
                                            </div>
                                        ))}
                                    </div>
                                }
                                {table.comparisonTableSectionsMiddle &&
                                    <div className="l-middle">
                                        <img loading="lazy" src={table.comparisonTableSectionsMiddle.sourceUrl} alt={table.comparisonTableSectionsMiddle.altText} />
                                        {table.comparisonTableSectionsMiddleText &&
                                            <span dangerouslySetInnerHTML={{__html: table.comparisonTableSectionsMiddleText}} />
                                        }
                                    </div>
                                }
                                {table.comparisonTableSectionsRight &&
                                    <div className="l-right">
                                        {data.comparisonTableLogoTwo &&
                                            <div className="l--mobile">
                                                <img loading="lazy" src={data.comparisonTableLogoTwo.sourceUrl} alt={data.comparisonTableLogoTwo.altText} />
                                            </div>

                                        }
                                        {table.comparisonTableSectionsRight.map((data, index) => (
                                            <div className="l-right__content" key={index}>
                                                {data.header ?
                                                    <h4>{data.header}</h4>
                                                    :
                                                    <h4 className="l-transform">no header</h4>
                                                }
                                                {data.teaser &&
                                                    <p dangerouslySetInnerHTML={{ __html: data.teaser }} />
                                                }
                                            </div>
                                        ))}
                                    </div>
                                }
                            </div>
                        ))}
                    </div>
                }
            </div>
        </div>
    );
}

export default ComparisonTableModule;